<template>
    <section class="fleet-setup-team-setup mb-2">
        <div class="team-added-card">
            <div class="team-added-header">
                <div class="complete-icon">
                    <icon name="faCheck" type="solid"></icon>
                </div>

                <div>
                    <h2 class="my-0 td-h4">Add Your Team</h2>
                </div>
            </div>

            <p v-if="!isLoading && users.length > 0" class="td-text-success td-text-mice mt-1 mb-0">You have {{ numInvited }} and {{ numUsers }} on your account.</p>
            <p v-if="!isLoading && users.length == 0" class="mt-1 mb-0">You have no other users on your account.  Invite a user to begin collaborating with your team.</p>
            <p class="td-text-mice td-text-subdued">
                You can add or remove members at any time in your <a href="/accounts/team-management" title="Team Settings" class="td-link">Team settings</a>.
            </p>

            <div class="team-list">
                <div v-if="isLoading" class="loading">
                    <icon name="faSpinner" type="solid" spin></icon>
                </div>
                <div class="team-member"
                     v-for="user in users"
                     :key="user.id">
                    <div class="member-info">
                        <div class="member-avatar"><icon v-if="user.status != 5" name="faUser" type="solid"></icon><icon v-if="user.status == 5" name="faHourglass" type="solid"></icon></div>
                        <div class="member-data">
                            <span>{{ user.firstName }} {{ user.lastName }}<span v-if="user.status == 5">  (Invited)</span></span><br />
                            <span class="td-text-mice">{{ user.email }}</span>
                        </div>
                    </div>

                    <span :class="[{primary: user.isAdmin}, 'td-badge', 'dark']">
                        {{ getUserRole(user) }}
                    </span>
                </div>
            </div>

            <div class="team-actions">
                <button class="td-btn primary icon-left" @click="openUsersModal" title="Invite Team Member" :disabled="isLoading"> <icon name="faPlus" type="solid"></icon> <span v-if="invitedUsers.length > 0">Invite Another</span><span v-if="invitedUsers.length == 0">Invite User</span></button>
            </div>
        </div>

        <div v-if="showUsersModal">
            <invite-user @close-invite="closeInvite" :account-name="accountName" :account-id="accountId" :is-onboarding="true"></invite-user>
        </div>
    </section>
</template>

<script>
import script from './TeamSetup';
    export default script;</script>

<style lang="less">
    @import "./TeamSetup.less";
</style>